/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{resolveIncludes as e}from"./sources/resolver.js";const r={vertexShader:e("stencil/stencil.vert"),fragmentShader:e("stencil/stencil.frag")};export{r as stencil};
